export const buttonsContainerClasses = ['grid w-full grid-cols-2 justify-between gap-3'];
